export const promiseDelay = (t: number) => new Promise((resolve) => setTimeout(resolve, t)); 